import {
  doc,
  collection,
  setDoc,
  getFirestore,
  addDoc,
  getDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

import { getCollectionRef, getDocRef } from "../utils";

export async function initUserSearchDoc(data) {
  const searchRef = getDocRef("search/{{uid}}");
  if (!searchRef) return null;

  await setDoc(searchRef, data);
}

export async function getSearchInfo() {
  let res = {};
  const searchRef = getCollectionRef("users");

  const querySnapshot = await getDocs(searchRef);

  querySnapshot.forEach((doc) => {
    res[doc.id] = doc.data();
  });

  return res;
}

export async function getProfileInfo(uid) {
  let res = null;
  const personalInfoRef = getDocRef(`/users/${uid}`);

  const data = await getDoc(personalInfoRef);

  if (data) {
    res = data.data();
    res = { ...res, uid: personalInfoRef.id };
  }

  return res;
}

export async function getAttachedFiles(uid) {
  let attachementsRef = getCollectionRef(`users/${uid}/attachments`);
  attachementsRef = query(attachementsRef, orderBy("timestamp", "desc"));
  let res = [];

  const attachements = await getDocs(attachementsRef);

  attachements.forEach((at) => {
    if (at.data()) {
      res.push(at.data());
    }
  });

  return res;
}
